/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The AuthenticationError model module.
 * @module model/AuthenticationError
 * @version 1.0.0
 */
export default class AuthenticationError {
  /**
   * Constructs a new <code>AuthenticationError</code>.
   * @alias module:model/AuthenticationError
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>AuthenticationError</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AuthenticationError} obj Optional instance to populate.
   * @return {module:model/AuthenticationError} The populated <code>AuthenticationError</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AuthenticationError()

      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String')
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String')
      }
      if (data.hasOwnProperty('columns')) {
        obj['columns'] = ApiClient.convertToType(data['columns'], ['String'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/AuthenticationError.TypeEnum} type
   */
  type = undefined
  /**
   * @member {String} message
   */
  message = undefined
  /**
   * @member {Array.<String>} columns
   */
  columns = undefined

  /**
   * Allowed values for the <code>type</code> property.
   * @enum {String}
   * @readonly
   */
  static TypeEnum = {
    /**
     * value: "authentication_error"
     * @const
     */
    authentication_error: 'authentication_error'
  }
}
